<template>
  <button
    class="btn-all-filters"
    @click.prevent="showAllFilters"
  >
    <Icon :icon="csgFilter" />
    All filters
  </button>
</template>

<script setup>
import Icon from '@atomic-ui/icon';
import { csgFilter } from '@csgSvgIcons/icons';
import { fireTag } from '@vue-util/tagManager';
import useEnvParams from '@composables/useEnvParams';
import useFireTagAsync from '@modules/discovery/composables/useFireTagAsync';
import useHorizontalFacetsRef from '@components/FilteringFacets/composables/useHorizontalFacetsRef';
import useConvoAllFiltersButton from '@components/FilteringFacets/composables/useConvoAllFiltersButton';

const horizontalFacetsRef = useHorizontalFacetsRef();
const isConvoAllFiltersButton = useConvoAllFiltersButton();
const { enableAsyncAnalyticsTags } = useEnvParams();

function fireAllFiltersClick() {
  const utagData = {
    event_name: 'all filters click_convo filters',
    link_name: 'all filters click_convo filters',
  };
  if (enableAsyncAnalyticsTags) {
    useFireTagAsync(() => fireTag('link', utagData));
  } else {
    fireTag('link', utagData);
  }
}

function showAllFilters() {
  isConvoAllFiltersButton.value = true;
  const listOfFacets = horizontalFacetsRef?.value?.$refs;
  const allFiltersEl = listOfFacets?.['facet-button-filter']?.[0];
  allFiltersEl?.click();
  fireAllFiltersClick();
  isConvoAllFiltersButton.value = false;
}

</script>

<style lang="scss" scoped>
  .btn-all-filters{
      cursor: pointer;
      font-size: rem-calc(14px);
      display: flex;
      align-items: center;
      gap: 8px;
      text-decoration: underline;
  }
</style>
